exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notification-container {\n  padding-top: 20px;\n  max-width: 1170px;\n}\n", ""]);

// exports
